import { categories } from "@/mocks/categories";

export default function MoreCategories() {
  return (
    <section className="w-full px-6 md:px-10 py-16 md:py-24 bg-background-100">
      {/* Top Title */}
      <div className="mb-12">
        <h2 className="text-3xl md:text-5xl font-heading font-light text-foreground-950 mb-3">
          More Categories
        </h2>
        <p className="text-sm md:text-base text-foreground-600 max-w-md">
          Explore additional categories from the mulebuy spreadsheet database
        </p>
      </div>

      {/* 3-column Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
        {/* Jackets */}
        <a
          href={categories[3].url}
          target="_blank"
          rel="noopener nofollow"
          className="group cursor-pointer"
        >
          <div className="bg-white rounded-2xl overflow-hidden border border-background-200/70 hover:border-background-300/60 transition-all h-full flex flex-col">
            <div className="relative w-full h-48 md:h-56 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Minimalist%20product%20photography%20of%20a%20classic%20khaki%20beige%20utility%20jacket%20on%20warm%20sand%20colored%20surface%20soft%20natural%20daylight%20simple%20editorial%20style%20high%20quality%20modern%20lifestyle%20aesthetic%20neutral%20earth%20tones%20isolated%20product%20shot%20with%20delicate%20shadows&width=600&height=500&seq=mulebuy-more-jackets-x2&orientation=portrait"
                alt="Jackets category"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute bottom-3 left-3">
                <span className="inline-block px-3 py-1 rounded-full bg-white/90 backdrop-blur-sm text-xs font-semibold text-foreground-900">
                  Jackets
                </span>
              </div>
            </div>
            <div className="p-5 md:p-6 flex flex-col flex-1">
              <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground-950 text-center mb-3">
                Jackets
              </h3>
              <p className="text-xs text-foreground-500 text-center mb-4">
                Bombers, denim jackets, and outerwear
              </p>
              <div className="mt-auto">
                <span className="block w-full text-center px-5 py-2.5 rounded-full bg-foreground-950 text-white text-sm font-medium hover:bg-foreground-800 transition-all whitespace-nowrap">
                  Browse Jackets
                </span>
              </div>
            </div>
          </div>
        </a>

        {/* Pants/Shorts */}
        <a
          href={categories[4].url}
          target="_blank"
          rel="noopener nofollow"
          className="group cursor-pointer"
        >
          <div className="bg-white rounded-2xl overflow-hidden border border-background-200/70 hover:border-background-300/60 transition-all h-full flex flex-col">
            <div className="relative w-full h-48 md:h-56 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Minimalist%20product%20photography%20of%20relaxed%20fit%20cream%20beige%20linen%20trousers%20on%20warm%20sand%20colored%20surface%20soft%20natural%20daylight%20simple%20editorial%20style%20high%20quality%20modern%20lifestyle%20aesthetic%20neutral%20earth%20tones%20isolated%20product%20shot%20with%20delicate%20shadows&width=600&height=500&seq=mulebuy-more-pants-x2&orientation=portrait"
                alt="Pants/Shorts category"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute bottom-3 left-3">
                <span className="inline-block px-3 py-1 rounded-full bg-white/90 backdrop-blur-sm text-xs font-semibold text-foreground-900">
                  Pants
                </span>
              </div>
            </div>
            <div className="p-5 md:p-6 flex flex-col flex-1">
              <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground-950 text-center mb-3">
                Pants/Shorts
              </h3>
              <p className="text-xs text-foreground-500 text-center mb-4">
                Cargo pants, jeans, shorts, and trousers
              </p>
              <div className="mt-auto">
                <span className="block w-full text-center px-5 py-2.5 rounded-full border border-foreground-300 text-foreground-800 text-sm font-medium hover:border-foreground-500 hover:bg-foreground-50 transition-all whitespace-nowrap">
                  Browse Pants/Shorts
                </span>
              </div>
            </div>
          </div>
        </a>

        {/* Headwear */}
        <a
          href={categories[5].url}
          target="_blank"
          rel="noopener nofollow"
          className="group cursor-pointer"
        >
          <div className="bg-white rounded-2xl overflow-hidden border border-background-200/70 hover:border-background-300/60 transition-all h-full flex flex-col">
            <div className="relative w-full h-48 md:h-56 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Minimalist%20product%20photography%20of%20a%20soft%20moss%20green%20bucket%20hat%20on%20warm%20sand%20colored%20surface%20soft%20natural%20daylight%20simple%20editorial%20style%20high%20quality%20modern%20lifestyle%20aesthetic%20neutral%20earth%20tones%20isolated%20product%20shot%20with%20delicate%20shadows&width=600&height=500&seq=mulebuy-more-headwear-x2&orientation=portrait"
                alt="Headwear category"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute bottom-3 left-3">
                <span className="inline-block px-3 py-1 rounded-full bg-white/90 backdrop-blur-sm text-xs font-semibold text-foreground-900">
                  Headwear
                </span>
              </div>
            </div>
            <div className="p-5 md:p-6 flex flex-col flex-1">
              <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground-950 text-center mb-3">
                Headwear
              </h3>
              <p className="text-xs text-foreground-500 text-center mb-4">
                Caps, beanies, and streetwear headwear
              </p>
              <div className="mt-auto">
                <span className="block w-full text-center px-5 py-2.5 rounded-full border border-foreground-300 text-foreground-800 text-sm font-medium hover:border-foreground-500 hover:bg-foreground-50 transition-all whitespace-nowrap">
                  Browse Headwear
                </span>
              </div>
            </div>
          </div>
        </a>

        {/* Sets */}
        <a
          href={categories[6].url}
          target="_blank"
          rel="noopener nofollow"
          className="group cursor-pointer"
        >
          <div className="bg-white rounded-2xl overflow-hidden border border-background-200/70 hover:border-background-300/60 transition-all h-full flex flex-col">
            <div className="relative w-full h-48 md:h-56 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Minimalist%20product%20photography%20of%20a%20matching%20two%20piece%20coord%20set%20in%20soft%20sage%20and%20cream%20tonal%20colors%20on%20warm%20sand%20colored%20surface%20soft%20natural%20daylight%20simple%20editorial%20style%20high%20quality%20modern%20lifestyle%20aesthetic%20neutral%20earth%20tones%20elegant%20composition&width=600&height=500&seq=mulebuy-more-sets-x2&orientation=portrait"
                alt="Sets category"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute bottom-3 left-3">
                <span className="inline-block px-3 py-1 rounded-full bg-white/90 backdrop-blur-sm text-xs font-semibold text-foreground-900">
                  Sets
                </span>
              </div>
            </div>
            <div className="p-5 md:p-6 flex flex-col flex-1">
              <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground-950 text-center mb-3">
                Sets
              </h3>
              <p className="text-xs text-foreground-500 text-center mb-4">
                Coordinated fashion sets and bundles
              </p>
              <div className="mt-auto">
                <span className="block w-full text-center px-5 py-2.5 rounded-full bg-foreground-950 text-white text-sm font-medium hover:bg-foreground-800 transition-all whitespace-nowrap">
                  Browse Sets
                </span>
              </div>
            </div>
          </div>
        </a>

        {/* Accessories */}
        <a
          href={categories[9].url}
          target="_blank"
          rel="noopener nofollow"
          className="group cursor-pointer"
        >
          <div className="bg-white rounded-2xl overflow-hidden border border-background-200/70 hover:border-background-300/60 transition-all h-full flex flex-col">
            <div className="relative w-full h-48 md:h-56 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Minimalist%20product%20photography%20of%20elegant%20minimal%20watch%20and%20leather%20bracelet%20on%20warm%20sand%20colored%20surface%20soft%20natural%20daylight%20simple%20editorial%20style%20high%20quality%20modern%20lifestyle%20aesthetic%20neutral%20earth%20tones%20refined%20composition&width=600&height=500&seq=mulebuy-more-accessories-x2&orientation=portrait"
                alt="Accessories category"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute bottom-3 left-3">
                <span className="inline-block px-3 py-1 rounded-full bg-white/90 backdrop-blur-sm text-xs font-semibold text-foreground-900">
                  Accessories
                </span>
              </div>
            </div>
            <div className="p-5 md:p-6 flex flex-col flex-1">
              <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground-950 text-center mb-3">
                Accessories
              </h3>
              <p className="text-xs text-foreground-500 text-center mb-4">
                Watches, jewelry, sunglasses, and small goods
              </p>
              <div className="mt-auto">
                <span className="block w-full text-center px-5 py-2.5 rounded-full border border-foreground-300 text-foreground-800 text-sm font-medium hover:border-foreground-500 hover:bg-foreground-50 transition-all whitespace-nowrap">
                  Browse Accessories
                </span>
              </div>
            </div>
          </div>
        </a>

        {/* Bags */}
        <a
          href={categories[10].url}
          target="_blank"
          rel="noopener nofollow"
          className="group cursor-pointer"
        >
          <div className="bg-white rounded-2xl overflow-hidden border border-background-200/70 hover:border-background-300/60 transition-all h-full flex flex-col">
            <div className="relative w-full h-48 md:h-56 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Minimalist%20product%20photography%20of%20a%20textured%20tan%20leather%20tote%20bag%20on%20warm%20sand%20colored%20surface%20soft%20natural%20daylight%20simple%20editorial%20style%20high%20quality%20modern%20lifestyle%20aesthetic%20neutral%20earth%20tones%20elegant%20isolated%20product%20shot&width=600&height=500&seq=mulebuy-more-bags-x2&orientation=portrait"
                alt="Bags category"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute bottom-3 left-3">
                <span className="inline-block px-3 py-1 rounded-full bg-white/90 backdrop-blur-sm text-xs font-semibold text-foreground-900">
                  Bags
                </span>
              </div>
            </div>
            <div className="p-5 md:p-6 flex flex-col flex-1">
              <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground-950 text-center mb-3">
                Bags
              </h3>
              <p className="text-xs text-foreground-500 text-center mb-4">
                Backpacks, crossbody bags, and totes
              </p>
              <div className="mt-auto">
                <span className="block w-full text-center px-5 py-2.5 rounded-full bg-foreground-950 text-white text-sm font-medium hover:bg-foreground-800 transition-all whitespace-nowrap">
                  Browse Bags
                </span>
              </div>
            </div>
          </div>
        </a>
      </div>
    </section>
  );
}